<template>
  <div class="task-box">
    <div class="task-title">
      T1：成就事件梳理
    </div>
    <!--  -->
    <div class="task_f">
      <h3 class="label lable_spe">在你的人生经历中，有哪些 <span @click="alertModule1 = true" class="noun">成就事件</span>？</h3>
      <p class="smallP mt">1. 请回溯人生的每⼀个阶段，不要跳过任何⼀个；职业-大学-初高中-小学-童年。</p>
      <p class="smallP">2. 先从最近开始填写。</p>
    </div>
    <!-- 成就事件1 -->
    <div class="task_f clearfix">
      <h3 class="label">成就事件1<span class="accent">（用不超过50个字进行描述）</span></h3>
      <div class="input-mt">
        <textarea v-model="event1" placeholder="在......阶段，我......"></textarea>
      </div>
      <span class="float">{{event1.length}}/50</span>
    </div>
    <div class="cell clearfix">
      <!-- 成就感 -->
      <van-cell-group class="grouping pull-left clearfix">
        <van-field v-model="event1_attainsense" label="成就感" @click="pickerType(1)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
      <!-- 价值感 -->
      <van-cell-group class="grouping pull-right clearfix">
        <van-field v-model="event1_valuesense" label="价值感" @click="pickerType(2)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
    </div>
    <!-- 成就事件2 -->
    <div class="task_f clearfix">
      <h3 class="label">成就事件2<span class="accent">（用不超过50个字进行描述）</span></h3>
      <div class="input-mt">
        <textarea v-model="event2" placeholder="在......阶段，我......"></textarea>
      </div>
      <span class="float">{{event2.length}}/50</span>
    </div>
    <div class="cell clearfix">
      <!-- 成就感 -->
      <van-cell-group class="grouping pull-left clearfix">
        <van-field v-model="event2_attainsense" label="成就感" @click="pickerType(3)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
      <!-- 价值感 -->
      <van-cell-group class="grouping pull-right clearfix">
        <van-field v-model="event2_valuesense" label="价值感" @click="pickerType(4)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
    </div>
    <!-- 成就事件3 -->
    <div class="task_f clearfix">
      <h3 class="label">成就事件3<span class="accent">（用不超过50个字进行描述）</span></h3>
      <div class="input-mt">
        <textarea v-model="event3" placeholder="在......阶段，我......"></textarea>
      </div>
      <span class="float">{{event3.length}}/50</span>
    </div>
    <div class="cell clearfix">
      <!-- 成就感 -->
      <van-cell-group class="grouping pull-left clearfix">
        <van-field v-model="event3_attainsense" label="成就感" @click="pickerType(5)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
      <!-- 价值感 -->
      <van-cell-group class="grouping pull-right clearfix">
        <van-field v-model="event3_valuesense" label="价值感" @click="pickerType(6)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
    </div>
    <!-- 成就事件4 -->
    <div class="task_f clearfix">
      <h3 class="label">成就事件4<span class="accent">（用不超过50个字进行描述）</span></h3>
      <div class="input-mt">
        <textarea v-model="event4" placeholder="在......阶段，我......"></textarea>
      </div>
      <span class="float">{{event4.length}}/50</span>
    </div>
    <div class="cell clearfix">
      <!-- 成就感 -->
      <van-cell-group class="grouping pull-left clearfix">
        <van-field v-model="event4_attainsense" label="成就感" @click="pickerType(7)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
      <!-- 价值感 -->
      <van-cell-group class="grouping pull-right clearfix">
        <van-field v-model="event4_valuesense" label="价值感" @click="pickerType(8)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
    </div>
    <!-- 成就事件5 -->
    <div class="task_f clearfix">
      <h3 class="label">成就事件5<span class="accent">（用不超过50个字进行描述）</span></h3>
      <div class="input-mt">
        <textarea v-model="event5" placeholder="在......阶段，我......"></textarea>
      </div>
      <span class="float">{{event5.length}}/50</span>
    </div>
    <div class="cell clearfix">
      <!-- 成就感 -->
      <van-cell-group class="grouping pull-left clearfix">
        <van-field v-model="event5_attainsense" label="成就感" @click="pickerType(9)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
      <!-- 价值感 -->
      <van-cell-group class="grouping pull-right clearfix">
        <van-field v-model="event5_valuesense" label="价值感" @click="pickerType(10)" readonly />
        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
      </van-cell-group>
    </div>
    <!-- 提交 -->
    <div class="task-footer">
      <div @click="submitData" :class="[isAdopt ? 'active' : '', 'submit-task']">提交</div>
    </div>
    <!-- 去下一个任务弹窗-->
    <van-popup :close-on-click-overlay="false" v-model="nextModule">
      <div class="modules">
        <div class="head clearfix">
          <img @click="goTaskIndex" class="close" src="../../../assets/close.png" alt="" />
        </div>
        <div class="con-img">
          <img src="../../../assets/pr1.png" alt="" />
        </div>
        <div class="con-text">
          任务就像消消乐，完成就好，继续加油！
        </div>
        <router-link class="next-btn" :to="{path: 'project3_task2_new', query: objArg}">去开启下一任务</router-link>
      </div>
    </van-popup>
    <!-- 弹出成就事件 -->
    <van-popup class="explain" v-model="alertModule1">
      <div>
        <h2>成就事件:</h2>
        <div class="pps">
          指某件让你特别有成就感，非常满意的事；这件事可以是让你获得外在成功和很多人认同，也可以是让你内在觉得成功，很满意的事情。
        </div>
      </div>
    </van-popup>
    <van-popup v-model="picker_show" position="bottom">
      <!-- 成就感1 -->
      <van-picker v-show="picker_type==1" show-toolbar :default-index="event1_attainsense.length>0?(parseInt(event1_attainsense)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
      <!-- 价值感1 -->
      <van-picker v-show="picker_type==2" show-toolbar :default-index="event1_valuesense.length>0?(parseInt(event1_valuesense)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
      <!-- 成就感2 -->
      <van-picker v-show="picker_type==3" show-toolbar :default-index="event2_attainsense.length>0?(parseInt(event2_attainsense)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
      <!-- 价值感2 -->
      <van-picker v-show="picker_type==4" show-toolbar :default-index="event2_valuesense.length>0?(parseInt(event2_valuesense)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
      <!-- 成就感3 -->
      <van-picker v-show="picker_type==5" show-toolbar :default-index="event3_attainsense.length>0?(parseInt(event3_attainsense)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
      <!-- 价值感3 -->
      <van-picker v-show="picker_type==6" show-toolbar :default-index="event3_valuesense.length>0?(parseInt(event3_valuesense)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
      <!-- 成就感4 -->
      <van-picker v-show="picker_type==7" show-toolbar :default-index="event4_attainsense.length>0?(parseInt(event4_attainsense)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
      <!-- 价值感4 -->
      <van-picker v-show="picker_type==8" show-toolbar :default-index="event4_valuesense.length>0?(parseInt(event4_valuesense)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
      <!-- 成就感5 -->
      <van-picker v-show="picker_type==9" show-toolbar :default-index="event5_attainsense.length>0?(parseInt(event5_attainsense)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
      <!-- 价值感5 -->
      <van-picker v-show="picker_type==10" show-toolbar :default-index="event5_valuesense.length>0?(parseInt(event5_valuesense)-1):0" :columns="group_" @cancel="cancel" @confirm="confirm" />
    </van-popup>
  </div>
</template>
<script>
import { getroadbookdata, updateroadbookdata } from "@/api/course"
import { getStorage, setStorage } from "@/utils/tools"
import { shareCon } from "@/utils/wxconfig";
export default {
  data() {
      return {
        nextModule: false,
        alertModule1: false,
        isAdopt: false,
        event1: "",
        event1_attainsense: "",
        event1_valuesense: "",
        event2: "",
        event2_attainsense: "",
        event2_valuesense: "",
        event3: "",
        event3_attainsense: "",
        event3_valuesense: "",
        event4: "",
        event4_attainsense: "",
        event4_valuesense: "",
        event5: "",
        event5_attainsense: "",
        event5_valuesense: "",
        arrow: false,
        objArg: {
          cid: "",
          pid: "",
          id: "",
          name: ""
        },
        group_: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        picker_show: false,
        picker_type: 0,
      }
    },
    methods: {
      // 选择框退出
      cancel(data) {
        this.picker_show = false;
      },
      // 弹出选择框
      confirm(data) {
        if (this.picker_type == 1) {
          this.event1_attainsense = data;
        } else if (this.picker_type == 2) {
          this.event1_valuesense = data;
        } else if (this.picker_type == 3) {
          this.event2_attainsense = data;
        } else if (this.picker_type == 4) {
          this.event2_valuesense = data;
        } else if (this.picker_type == 5) {
          this.event3_attainsense = data;
        } else if (this.picker_type == 6) {
          this.event3_valuesense = data;
        } else if (this.picker_type == 7) {
          this.event4_attainsense = data;
        } else if (this.picker_type == 8) {
          this.event4_valuesense = data;
        } else if (this.picker_type == 9) {
          this.event5_attainsense = data;
        } else if (this.picker_type == 10) {
          this.event5_valuesense = data;
        }

        this.picker_show = false;

      },
      // 判断弹出是什么选择框
      pickerType(type) {
        this.picker_type = type;
        this.picker_show = true;
      },
      goTaskIndex() {
        let q = this.$route.query
        this.$router.push({
          path: 'project_details',
          query: {
            cid: q.cid,
            cpid: q.pid,
            type: 'trademap'
          }
        })
      },
      execState() {
        if (
          this.event1.length &&
          this.event1_attainsense.length &&
          this.event1_valuesense &&
          this.event2.length &&
          this.event2_attainsense.length &&
          this.event2_valuesense &&
          this.event3.length &&
          this.event3_attainsense.length &&
          this.event3_valuesense &&
          this.event4.length &&
          this.event4_attainsense.length &&
          this.event4_valuesense &&
          this.event5.length &&
          this.event5_attainsense.length &&
          this.event5_valuesense
        ) {
          this.isAdopt = true;
        } else {
          this.isAdopt = false;
        }
      },
      submitData() {
        if (!this.isAdopt) {
          return
        }
        // 提交
        let q = this.$route.query;
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        updateroadbookdata({
            cid: q.cid,
            cpid: q.pid,
            cptid: q.id,
            type: "taskone",
            iscreate: 1,
            event1: this.event1,
            event1_attainsense: this.event1_attainsense,
            event1_valuesense: this.event1_valuesense,
            event2: this.event2,
            event2_attainsense: this.event2_attainsense,
            event2_valuesense: this.event2_valuesense,
            event3: this.event3,
            event3_attainsense: this.event3_attainsense,
            event3_valuesense: this.event3_valuesense,
            event4: this.event4,
            event4_attainsense: this.event4_attainsense,
            event4_valuesense: this.event4_valuesense,
            event5: this.event5,
            event5_attainsense: this.event5_attainsense,
            event5_valuesense: this.event5_valuesense,
          })
          .then((data) => {
            let d = data;
            let q = this.$route.query;
            this.$toast.clear();
            this.objArg = {
              cid: q.cid,
              pid: q.pid,
              id: d.cptid,
              name: encodeURIComponent(d.name)
            }
              // show module
            if (d.bot_done_status == 2 && d.pmq_done_status == 1) {
              this.$router.push({path:'/project3_eggs',query:{cid:this.cid}});
            } else {
              this.nextModule = true;
            }

          })
      },
      pullData() {
        getroadbookdata({
            cid: this.$route.query.cid,
            type: "taskone"
          })
          .then((data) => {
            let {
              event1,
              event1_attainsense,
              event1_valuesense,
              event2,
              event2_attainsense,
              event2_valuesense,
              event3,
              event3_attainsense,
              event3_valuesense,
              event4,
              event4_attainsense,
              event4_valuesense,
              event5,
              event5_attainsense,
              event5_valuesense,
            } = data.data;
            if (
              event1 &&
              event1_attainsense &&
              event1_valuesense &&
              event2 &&
              event2_attainsense &&
              event2_valuesense &&
              event3 &&
              event3_attainsense &&
              event3_valuesense &&
              event4 &&
              event4_attainsense &&
              event4_valuesense &&
              event5 &&
              event5_attainsense &&
              event5_valuesense
            ) {
              // 设置服务器已提交的数据
              this.setDataVal(true, data.data);
            } else {
              this.setDataVal(false);
            }

          })
      },
      setDataVal(bool, d) {
        let path = this.$route.path;
        this.event1 = bool ? d.event1 : getStorage(path, 'event1') || '';
        this.event1_attainsense = bool ? d.event1_attainsense : getStorage(path, 'event1_attainsense') || '';
        this.event1_valuesense = bool ? d.event1_valuesense : getStorage(path, 'event1_valuesense') || '';
        this.event2 = bool ? d.event2 : getStorage(path, 'event2') || '';
        this.event2_attainsense = bool ? d.event2_attainsense : getStorage(path, 'event2_attainsense') || '';
        this.event2_valuesense = bool ? d.event2_valuesense : getStorage(path, 'event2_valuesense') || '';
        this.event3 = bool ? d.event3 : getStorage(path, 'event3') || '';
        this.event3_attainsense = bool ? d.event3_attainsense : getStorage(path, 'event3_attainsense') || '';
        this.event3_valuesense = bool ? d.event3_valuesense : getStorage(path, 'event3_valuesense') || '';
        this.event4 = bool ? d.event4 : getStorage(path, 'event4') || '';
        this.event4_attainsense = bool ? d.event4_attainsense : getStorage(path, 'event4_attainsense') || '';
        this.event4_valuesense = bool ? d.event4_valuesense : getStorage(path, 'event4_valuesense') || '';
        this.event5 = bool ? d.event5 : getStorage(path, 'event5') || '';
        this.event5_attainsense = bool ? d.event5_attainsense : getStorage(path, 'event5_attainsense') || '';
        this.event5_valuesense = bool ? d.event5_valuesense : getStorage(path, 'event5_valuesense') || '';
        // 判断时候允许提交
        this.execState();
      },
      setTitle() {
        let title = this.$route.query.name;
        document.title = decodeURI(title);
      }
    },
    created() {
      this.pullData();
      this.setTitle();
      shareCon("course",this);
    },
    watch: {
      event1(curVal, oldVal) {
        if (curVal.length > 50) {
          this.event1 = curVal.slice(0, 50);
          this.$toast('最多只能输入50个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'event1', curVal);
        };
        this.execState();
      },
      event1_attainsense(curVal, oldVal) {
        setStorage(this.$route.path, 'event1_attainsense', curVal);
        this.execState();
      },
      event1_valuesense(curVal, oldVal) {
        setStorage(this.$route.path, 'event1_valuesense', curVal);
        this.execState();
      },
      event2(curVal, oldVal) {
        if (curVal.length > 50) {
          this.event2 = curVal.slice(0, 50);
          this.$toast('最多只能输入50个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'event2', curVal);
        };
        this.execState();
      },
      event2_attainsense(curVal, oldVal) {
        setStorage(this.$route.path, 'event2_attainsense', curVal);
        this.execState();
      },
      event2_valuesense(curVal, oldVal) {
        setStorage(this.$route.path, 'event2_valuesense', curVal);
        this.execState();
      },
      event3(curVal, oldVal) {
        if (curVal.length > 50) {
          this.event3 = curVal.slice(0, 50);
          this.$toast('最多只能输入50个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'event3', curVal);
        };
        this.execState();
      },
      event3_attainsense(curVal, oldVal) {
        setStorage(this.$route.path, 'event3_attainsense', curVal);
        this.execState();
      },
      event3_valuesense(curVal, oldVal) {
        setStorage(this.$route.path, 'event3_valuesense', curVal);
        this.execState();
      },
      event4(curVal, oldVal) {
        if (curVal.length > 50) {
          this.event4 = curVal.slice(0, 50);
          this.$toast('最多只能输入50个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'event4', curVal);
        };
        this.execState();
      },
      event4_attainsense(curVal, oldVal) {
        setStorage(this.$route.path, 'event4_attainsense', curVal);
        this.execState();
      },
      event4_valuesense(curVal, oldVal) {
        setStorage(this.$route.path, 'event4_valuesense', curVal);
        this.execState();
      },
      event5(curVal, oldVal) {
        if (curVal.length > 50) {
          this.event5 = curVal.slice(0, 50);
          this.$toast('最多只能输入50个字。/(ㄒoㄒ)/~~');
        } else {
          setStorage(this.$route.path, 'event5', curVal);
        };
        this.execState();
      },
      event5_attainsense(curVal, oldVal) {
        setStorage(this.$route.path, 'event5_attainsense', curVal);
        this.execState();
      },
      event5_valuesense(curVal, oldVal) {
        setStorage(this.$route.path, 'event5_valuesense', curVal);
        this.execState();
      },
    }
}
</script>
<style lang="scss" scoped>
@import "@s/taskStyle.scss";
.explain {
  width: changeRem(13)+px;
  height: auto;
  border-radius: changeRem(0.16)+px;
  background: #fff;
  text-align: center;
  padding: changeRem(0.8)+px changeRem(1.2)+px;
  h2 {
    text-align: justify;
    margin-top: 0;
    font-size: changeRem(0.64)+px;
    color: #EB5032;
    font-weight: normal;
    margin-bottom: changeRem(0.2)+px;
  }
  .pps {
    color: #333;
    font-size: changeRem(0.52)+px;
    line-height: changeRem(0.8)+px;
    text-align: justify;
  }
}

.task_f {
  .label.lable_spe {
    color: #333;
    .noun {
      color: #EB5032
    }
  }
  p {
    font-size: changeRem(0.48)+px;
    color: #666666;
    line-height: changeRem(0.84)+px;
    text-align: justify;
  }
  p.mt {
    margin-top: changeRem(0.2)+px;
  }
  &:last-child p {
    background: #333
  }
}

.grouping {
  margin-top: 20px;
  width: 280px
}
</style>
